export default {
  catAll: 'All',
  catPurchasing: 'Purchasing',
  catKeyActivation: 'Key activation',
  catAccount: 'Account',
  catBilling: 'Billing',
  catRefunds: 'Refunds',

  eyebrow: 'FAQ',
  eyebrowSubtitle: 'Find answers to common questions',

  title: 'FAQ',
  subtitle: 'Search the database or filter by category.',

  heroTitle: 'Frequently asked',
  heroTitleAccent: 'questions',
  heroSubtitle: 'System database accessed. Search for solutions or browse categories below.',
  searchPlaceholder: 'QUERY...',
  noResults: 'No results. Try a different search or category.',

  stillNeedHelpTitle: 'Still need help?',
  stillNeedHelpBody: "If your question isn't covered above, reach out and our team will get back to you.",
  contactSupport: 'Contact support',

  q1: 'How do I buy a game key?',
  q1Intro: 'Buying a key on PixelKey is an instant, automated process. Just follow these steps:',
  q1Step1: 'Browse the Catalog and open the game you want.',
  q1Step2: 'Click “Add to cart”, then open your cart.',
  q1Step3: 'Go to checkout and pay with your wallet balance (top up first if needed).',
  q1Step4: 'Once payment clears, the key appears instantly in “My Orders” — reveal it and activate.',

  q2: 'Are the keys region locked?',
  q2A: 'Some keys have regional restrictions. Each product page shows a “Regional Restrictions” notice when a key only activates in certain regions; region-free keys work worldwide. Always check the product page before buying.',

  q3: 'How long does activation take?',
  q3A: 'Delivery is instant — the moment your payment clears, the key is available in My Orders. Activating it on the platform (Steam, Epic, etc.) usually takes under a minute.',

  q4: 'How do I activate my key?',
  q4A: 'Open My Orders, reveal the key, then redeem it in the matching platform client (e.g. Steam → Games → Activate a Product). Each order includes step-by-step activation instructions.',

  q5: 'How do I top up my wallet?',
  q5A: 'Go to your Dashboard or Checkout and click “Top up”. Choose an amount and pay via the hosted checkout; your wallet balance updates as soon as the payment is confirmed.',

  q6: 'How do I verify my email?',
  q6A: 'After signing up we email you a verification link. Click it to verify your address — this unlocks purchases up to €50. You can resend it from your Dashboard if needed.',

  q7: 'Can I delete my account?',
  q7A: 'Yes. In Account Settings → Danger Zone you can schedule deletion. Your account is removed after a 7-day grace period, and you can cancel anytime before then.',

  q8: 'What is the refund policy?',
  q8A: 'Unrevealed keys can be refunded. Once a key has been revealed or activated it cannot be refunded, since digital keys are non-recoverable. Contact support if something went wrong with your order.',

  q9: 'What payment methods are accepted?',
  q9A: 'You pay from your PixelKey wallet balance. Top it up with a card through our hosted checkout — the wallet then covers any order instantly, with no card details stored on our servers.',

  q10: 'Where do I find my purchased keys?',
  q10A: 'Every key lives in My Orders. Open the order, click reveal, and the activation code is shown — each reveal is logged for your security.',

  q11: 'Do I need an account to buy?',
  q11A: 'Yes. A free account ties your orders, wallet balance and keys to you, so your purchases are always recoverable. Sign-up takes under a minute with just an email and password.',

  q12: 'Is my payment information secure?',
  q12A: 'Card data never touches our servers — payments are handled by our PCI-compliant provider over a hosted checkout. We only ever store your wallet balance, never your card.',

  q13: 'Where can I see my purchase history?',
  q13A: 'Your full order and wallet history is in Account → Billing: every purchase, top-up and transaction with dates and amounts.',

  q14: 'How do I request a refund?',
  q14A: 'If a key is still unrevealed, contact support from the "Still need help" section below with your order ID and we will reverse it to your wallet. Revealed keys cannot be refunded.',

  q15: 'My order is stuck on "processing" — what should I do?',
  q15A: 'Most orders deliver in seconds, but during a supplier check an order can sit in PROCESSING briefly. If it has not cleared within a few minutes, contact support with your order ID and we will resolve it or refund you.',
};
